import Marquee from "react-fast-marquee";

export default function MarqueeBanner() {
  return (
    <section className="relative bg-gradient-to-r from-orange-500 via-yellow-400 to-orange-500 border-y-4 border-black overflow-hidden">
      <div className="overflow-hidden" style={{ height: "clamp(70px, 9vw, 140px)" }}>
        <Marquee gradient={false} speed={55} pauseOnHover={false} className="h-full">
          <div className="flex items-center gap-12 mr-12 font-heading text-black uppercase whitespace-nowrap leading-none" style={{ fontSize: "clamp(2.5rem, 7vw, 6rem)" }}>
            <span>No es solo un campamento</span>
            <span className="text-white">✦</span>
            <span style={{ WebkitTextStroke: "2px #000", color: "transparent" }}>
              Es una experiencia divina
            </span>
            <span className="text-white">✦</span>
            <span>Agosto 28, 2026</span>
            <span className="text-white">✦</span>
          </div>
        </Marquee>
      </div>
    </section>
  );
}
